import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useReactRouter from 'use-react-router';
import { makeStyles, createStyles } from '@material-ui/styles';
import AccountContext from '../Context/AccountContext';
import { useProfileContext } from '../Context/ProfileContext';
import TagManager from 'react-gtm-module';
import { Breadcrumb } from 'da-frontend-shared-ui-components';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(() => 
  createStyles({
    root: {
      "& svg": {
        marginBottom: '3px'
      },
    }
  })
);

/**
 * Breadcrumbs renderer
 *
 * ex) Account Management |> My Dealer Name |> Customer Accounts
 */
const Breadcrumbs = () => {
  const classes   = useStyles();
  const { t }     = useTranslation();
  const [ state ] = useContext(AccountContext);
  const profile = useProfileContext();
  const { match } = useReactRouter();
  const section   = match.params["section"];

  // Call when no account specified; sets GA with logged in user's id an preferred account info
  const gaSetToUsersPreferredAccount = () => {
    const gaUserId = (profile && profile.userId) ? profile.userId : undefined;
    const gaAccountId = (profile && profile.preferredAccount && profile.preferredAccount.id) ? profile.preferredAccount.id : undefined;
    const gaAccountType = (profile && profile.preferredAccount && profile.preferredAccount.type) ? profile.preferredAccount.type : undefined;

    TagManager.dataLayer({
      dataLayer: {
        userId: gaUserId,
        accountType: gaAccountType,
        accountId: gaAccountId,
      }
    });
  };

  let paths = [
    {
      label: t('nav.Account Management'),
      to: '/',
      onClick: gaSetToUsersPreferredAccount
    }
  ];

  if (state.account) {
    paths.push({
      label: state.account.name,
      to: `/${state.account.id}`,
      onClick: null
    });
  }
      
  if (section) {
    paths.push({
      label: (section) ? section : '',
      to: null,
      onClick: null
    }) ;
  }

  return (
    <Grid container className={classes.root}>
      <Breadcrumb paths={paths} />
    </Grid>
  )
}

export default Breadcrumbs
